import styles from '../css/DatoContacto.module.scss'

export const DatoContacto = ({ logo, dato, className, isTopBar }) => {
    return (
        <>
            <div className={'d-inline-block ' + className}>
                <img src={logo} className={"d-inline-block " + (isTopBar? styles.iconoTopBar:'')} />
                <p className={'mb-0 d-inline-block ' + (isTopBar? 'ms-3':'ms-5')}>
                    {dato}
                </p>
            </div>
        </>
    )
}